// extracted by mini-css-extract-plugin
export var formContainer = "_er-0";
export var message = "_er-1";